import { IconCheckOutline18 } from 'nucleo-ui-outline-18'
import { WhatsAppMockup } from './mockups/modules'
import { ScrollReveal } from './scroll-reveal'
import { TruchetField } from './truchet-field'

/*
 * Canais — a single band for the one channel the office already lives in.
 * Copy on the left, the conversation itself on the right. No subpage.
 */

const POINTS = [
  {
    body: 'Peça em uma frase e a tarefa nasce no projeto certo, com responsável e prazo. Sem abrir o computador.',
    title: 'Crie tarefas por mensagem',
  },
  {
    body: 'Pergunte o que ficou pendente na visita, quantas fotos chegaram da obra ou como está o sprint. A resposta vem do que está no Planno.',
    title: 'Consulte a obra conversando',
  },
  {
    body: 'A conversa fica ligada ao projeto e ao contato certos — nada se perde no grupo da obra.',
    title: 'Tudo ligado ao projeto',
  },
]

export const CanaisBento = () => (
  <section className="relative overflow-hidden bg-[#f4f7f3] py-24">
    <TruchetField
      className="absolute inset-0 h-full w-full text-[#0b0b0d] opacity-[0.05]"
      seed="canais"
    />
    <div className="relative mx-auto grid max-w-[1120px] items-center gap-12 px-6 md:grid-cols-[1fr_minmax(0,380px)] md:gap-16">
      <ScrollReveal>
        <h2 className="max-w-[540px] font-display text-[#0b0b0d] text-[clamp(32px,4.6vw,48px)] leading-[1.06] tracking-[-0.01em]">
          O escritório no WhatsApp, sem virar mais uma aba
        </h2>
        <p className="mt-5 max-w-[480px] text-[#6c6c72] text-[clamp(15px,2vw,18px)] leading-relaxed">
          O canal em que a obra já fala com você, agora ligado ao projeto. Você escreve como
          escreveria para a equipe, e o Planno faz o resto.
        </p>
        <div className="mt-9 space-y-6">
          {POINTS.map((point) => (
            <div className="flex gap-3" key={point.title}>
              <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-[#dfeedb] text-[#3e7d33]">
                <IconCheckOutline18 className="size-3" />
              </span>
              <div>
                <h3 className="font-bold text-[#0b0b0d] text-[15px]">{point.title}</h3>
                <p className="mt-1 max-w-[420px] text-[#6c6c72] text-[13.5px] leading-relaxed">
                  {point.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </ScrollReveal>
      <ScrollReveal delay={120}>
        <WhatsAppMockup />
      </ScrollReveal>
    </div>
  </section>
)
